/* JTM - Jonny Custom Quantity Input Fields Min Max Validation v1.2 */
(() => {

$q('html.q-is-loaded').wait(true,(elm) => {

  const SEL_WRAP  = 'quantity-input .qty-input';
  const SEL_INPUT = 'quantity-input .qty-input__input[type="number"]';
  const SEL_BTN   = '.qty-input__btn[name="minus"], .qty-input__btn[name="plus"]';

  const clamp = (n, min, max) => {
    if (Number.isFinite(min) && n < min) return min;
    if (Number.isFinite(max) && n > max) return max;
    return n;
  };

  const getBounds = (input) => {
    const minAttr = input.getAttribute('min');
    const maxAttr = input.getAttribute('max');
    const min = minAttr !== null && minAttr !== '' ? Number(minAttr) : undefined;
    const max = maxAttr !== null && maxAttr !== '' ? Number(maxAttr) : undefined;
    return { min: Number.isFinite(min) ? min : undefined, max: Number.isFinite(max) ? max : undefined };
  };

  const getEffectiveBounds = (input) => {
    const { min, max } = getBounds(input);

    // Shopify cart remove behavior: prevent qty 0 even if min="0"
    const effMin = (min === 0 ? 1 : min);

    return { min: effMin, max };
  };

  const formatHint = (min, max) => {
    if (min === 1 && max !== undefined) {
      return `Max Quantity is <b>${max}</b>`;
    }
    if (min !== undefined && max !== undefined) {
      return `Min Quantity is <b>${min}</b> • Max Quantity is <b>${max}</b>`;
    }
    if (min !== undefined && min != 0) {
      return `Min Quantity is <b>${min}</b>`;
    }
    if (max !== undefined) {
      return `Max Quantity is <b>${max}</b>`;
    }
    return '';
  };

  const setValue = (input, next, emit) => {
    input.value = String(next);
    if (emit) {
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  };

  const rememberPrev = (input) => {
    const n = Number(input.value);
    const { min, max } = getEffectiveBounds(input);
    if (Number.isFinite(n)) input.dataset.qtyPrev = String(n);
    else input.dataset.qtyPrev = String(min ?? max ?? 1);
  };

  const updateBtnsDisabled = (wrap, input) => {
    const { min, max } = getEffectiveBounds(input);
    const n = Number(input.value);
    const minus = wrap.querySelector('.qty-input__btn[name="minus"]');
    const plus  = wrap.querySelector('.qty-input__btn[name="plus"]');

    if (minus) minus.disabled = Number.isFinite(n) && min !== undefined ? n <= min : false;
    if (plus)  plus.disabled  = Number.isFinite(n) && max !== undefined ? n >= max : false;
  };

  // ===== Hint UI (.qty-hint) =================================================
  /* const ensureHint = (wrap, input) => {
    let hint = wrap.querySelector('.qty-hint');
    if (!hint) {
      hint = document.createElement('div');
      hint.className = 'qty-hint';
      hint.setAttribute('aria-hidden', 'true');
      wrap.appendChild(hint);
    }

    const { min, max } = getEffectiveBounds(input);
    const text = formatHint(min, max);

    hint.innerHTML = text;
    hint.style.display = text ? '' : 'none';
    return hint;
  }; */
  const ensureHint = (wrap, input) => {
    let hint = wrap.querySelector('.qty-hint');

    if (!hint) {
      hint = document.createElement('div');
      hint.className = 'qty-hint';
      hint.setAttribute('aria-hidden', 'true');
      wrap.appendChild(hint);
    }

    const bounds = getBounds(input);
    const rawMin = bounds.min;
    const rawMax = bounds.max;

    // Hide hint when original min is 0 or 1
    if (rawMin === 0 || rawMin === 1) {
      hint.innerHTML = '';
      hint.style.display = 'none';
      return hint;
    }

    // Otherwise use effective bounds for display
    const effective = getEffectiveBounds(input);
    const min = effective.min;
    const max = effective.max;

    const text = formatHint(min, max);

    hint.innerHTML = text;

    if (text) {
      hint.style.display = '';
    } else {
      hint.style.display = 'none';
    }

    return hint;
  };



  const refreshHintAndButtons = (wrap, input) => {
    if (!wrap) return;
    ensureHint(wrap, input);
    updateBtnsDisabled(wrap, input);
  };

  // ===== Binding =============================================================
  function bindQty(input) {
    if (input.dataset.qtyBound === '1') return;

    const { min, max } = getBounds(input);
    if (min === undefined && max === undefined) return;

    // do not bind when min="1" and there is no max attribute
    if (min === 1 && !input.hasAttribute('max')) return;

    input.dataset.qtyBound = '1';

    const wrap = input.closest(SEL_WRAP);
    refreshHintAndButtons(wrap, input);

    if (wrap) {
      input.addEventListener('focus', () => wrap.classList.add('is-focused'), true);
      input.addEventListener('blur',  () => wrap.classList.remove('is-focused'), true);

      // Keep hint/buttons updated if min/max changes dynamically
      const mo = new MutationObserver(() => refreshHintAndButtons(wrap, input));
      mo.observe(input, { attributes: true, attributeFilter: ['min','max','value'] });
    }

    input.addEventListener('focus', () => rememberPrev(input), true);
    input.addEventListener('pointerdown', () => rememberPrev(input), true);
    input.addEventListener('touchstart', () => rememberPrev(input), { passive: true });

    // Digits only (Shopify qty is integer)
    input.addEventListener('keydown', (e) => {
      if (e.ctrlKey || e.metaKey || e.altKey) return;
      const ok = ['Backspace','Delete','ArrowLeft','ArrowRight','Tab','Home','End','Enter','Escape'];
      if (ok.includes(e.key)) return;
      if (!/^[0-9]$/.test(e.key)) e.preventDefault();
    });

    // Revert if next would be out of bounds (typing/paste on supported browsers)
    input.addEventListener('beforeinput', (e) => {
      const t = e.inputType || '';
      if (t.startsWith('delete')) return;

      const { min: min2, max: max2 } = getEffectiveBounds(input);

      const start = input.selectionStart ?? input.value.length;
      const end = input.selectionEnd ?? input.value.length;
      const insert = e.data ?? '';
      const nextStr = input.value.slice(0, start) + insert + input.value.slice(end);

      if (nextStr === '') return;
      if (!/^[0-9]+$/.test(nextStr)) { e.preventDefault(); return; }

      const nextNum = Number(nextStr);
      const out = (min2 !== undefined && nextNum < min2) || (max2 !== undefined && nextNum > max2);

      if (out) {
        e.preventDefault();
        const prev = input.dataset.qtyPrev;
        if (prev !== undefined) {
          setValue(input, prev, false);
          e.stopPropagation();
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        }
      }
    });

    // Catch-all: if anything sets value out of range, revert to previous
    input.addEventListener('input', (e) => {
      const { min: min2, max: max2 } = getEffectiveBounds(input);

      if (input.value === '') return;

      const n = Number(input.value);
      if (!Number.isFinite(n)) {
        const prev = input.dataset.qtyPrev;
        if (prev !== undefined) input.value = prev;
        return;
      }

      const clamped = clamp(n, min2, max2);
      if (clamped !== n) {
        const prev = input.dataset.qtyPrev;

        // silent revert (DO NOT emit input/change)
        if (prev !== undefined) setValue(input, prev, false);

        // kill theme/shopify ajax listeners that fire on keyup/input
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();

        refreshHintAndButtons(wrap, input);
        return;
      }

      input.dataset.qtyPrev = String(n);
      refreshHintAndButtons(wrap, input);
    });

    // On blur: normalize empties + ensure final value is valid
    input.addEventListener('blur', () => {
      const { min: min2, max: max2 } = getEffectiveBounds(input);

      if (input.value === '') {
        const fallback = min2 ?? 1;
        setValue(input, fallback, true);
        input.dataset.qtyPrev = String(fallback);
        refreshHintAndButtons(wrap, input);
        return;
      }

      const n = Number(input.value);
      if (!Number.isFinite(n)) {
        const fallback = min2 ?? 1;
        setValue(input, fallback, true);
        input.dataset.qtyPrev = String(fallback);
        refreshHintAndButtons(wrap, input);
        return;
      }

      const fixed = clamp(n, min2, max2);
      if (fixed !== n) setValue(input, fixed, true);
      input.dataset.qtyPrev = String(fixed);
      refreshHintAndButtons(wrap, input);
    });

    // Optional “belt and suspenders” (if Shopify listens to keyup)
    input.addEventListener('keyup', (e) => {
      // Allow empty while the user edits (so Backspace works)
      if (input.value === '') return;

      const { min: min2, max: max2 } = getEffectiveBounds(input);
      const n = Number(input.value);
      if (!Number.isFinite(n)) return;

      const out = (min2 !== undefined && n < min2) || (max2 !== undefined && n > max2);
      if (!out) return;

      const prev = input.dataset.qtyPrev;
      if (prev !== undefined) setValue(input, prev, false);

      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }, true);
  }

  // Delegate +/- clicks (works for cart drawers that re-render)
  function onBtnClick(e) {
    const btn = e.target.closest(SEL_BTN);
    if (!btn) return;

    const wrap = btn.closest(SEL_WRAP);
    if (!wrap) return;

    const input = wrap.querySelector('.qty-input__input[type="number"]');
    if (!input) return;

    bindQty(input);
    rememberPrev(input);

    const { min, max } = getEffectiveBounds(input);

    const step = Number(input.getAttribute('step')) || 1;
    const cur = Number(input.value);
    const nextRaw = btn.name === 'plus' ? cur + step : cur - step;
    const next = clamp(nextRaw, min, max);

    if (next === cur) { refreshHintAndButtons(wrap, input); return; }

    setValue(input, next, true);
    input.dataset.qtyPrev = String(next);
    refreshHintAndButtons(wrap, input);

    // Avoid double increment if theme also handles click
    e.preventDefault();
    e.stopPropagation();
  }

  function bindAll() {
    document.querySelectorAll(SEL_INPUT).forEach(bindQty);
  }

  // ===== observeCartRoot (Option B) =========================================
  function observeCartRoot(root) {
    if (!root) return;
    if (root.dataset.qtyObserver === '1') return;
    root.dataset.qtyObserver = '1';

    const mo = new MutationObserver((muts) => {
      for (const m of muts) {
        for (const node of m.addedNodes) {
          if (!(node instanceof Element)) continue;
          if (node.matches && node.matches(SEL_INPUT)) bindQty(node);
          if (node.querySelectorAll) node.querySelectorAll(SEL_INPUT).forEach(bindQty);
        }
      }
    });

    mo.observe(root, { childList: true, subtree: true });

    // Immediate sweep
    root.querySelectorAll(SEL_INPUT).forEach(bindQty);
  }

  // ===== init ================================================================
  bindAll();
  document.addEventListener('click', onBtnClick, true);

  // Observe drawer + cart + common cart containers (AJAX re-renders)
  observeCartRoot(document.querySelector('#cart-drawer'));
  observeCartRoot(document.querySelector('#cart'));

  [
    '#main-cart-items',
    'cart-items',
    '#CartItems',
    '.cart__items',
    'form[action="/cart"]'
  ].forEach((sel) => observeCartRoot(document.querySelector(sel)));

}); // wait for html.q-loaded
})(); // IIFE
